import { useTranslate } from "@refinedev/core";
import { Grid2 as Grid, Typography } from "@mui/material";

import { Form } from "@shared/components";

export function ModulesFields() {
  const translate = useTranslate();

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12 }}>
        <Typography style={{ fontSize: 18, color: "primary.main" }}>
          Modulos de Vinculação
        </Typography>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="physical_card_module"
          label={translate("v1/agreement_admin.fields.physical_card_module")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Typography style={{ fontSize: 18, color: "primary.main" }}>
          Módulos de Funcionalidades
        </Typography>
      </Grid>

      <Grid size={{ xs: 6, lg: 4 }}>
        <Form.Switch
          name="referral_module"
          label={translate("v1/agreement_admin.fields.referral_module")}
        />
      </Grid>

      <Grid size={{ xs: 6, lg: 4 }}>
        <Form.Switch
          name="product_module"
          label={"Módulo Super App"}
        />
      </Grid>

      <Grid size={{ xs: 6, lg: 4 }}>
        <Form.Switch
          name="has_integrated_purchase_on_mobile_store"
          label={"Possui integração de pagamento na versao do APP"}
        />
      </Grid>
      <Grid size={{ xs: 6, lg: 4 }}>
        <Form.Switch
          name="allow_default_plan_on_integration"
          label={"Permite mapeamento de plano default na integração"}
        />
      </Grid>
      <Grid size={{ xs: 6, lg: 4 }}>
        <Form.Switch
          name="same_subscription_for_supervised_agreements"
          label={"Define se os convênios supervisionados terão a mesma assinatura"}
        />
      </Grid>


      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="ura_module_cellphone"
          label={translate("v1/agreement_admin.fields.ura_module_cellphone")}
          mask="phone"
        />
      </Grid>

      <Grid size={{ xs: 6, lg: 4 }}>
        <Form.Select
          name="agreement_for_login_use"
          label={'Convenio para logar em Apps Partiu'}
          options={[
            { label: "Partiu Vantagens", value: 641 },
          ]}
        />
      </Grid>
    </Grid>
  );
}
